import { IyzicoSavedCard } from '@/models/Order';
import { CreditCard } from 'lucide-react';

function cardTypeLabel(cardType?: string | null): string {
  const t = String(cardType || '').toUpperCase();
  if (t === 'DEBIT_CARD') return 'Banka Kartı';
  if (t === 'PREPAID_CARD') return 'Ön Ödemeli Kart';
  return 'Kredi Kartı';
}

export function savedCardTitle(card: IyzicoSavedCard): string {
  const type = cardTypeLabel(card.cardType);
  const family = String(card.cardFamily || '').trim();
  if (family) return `${family} - ${type}`;
  return card.cardAlias || type;
}

function brandKey(association?: string | null): 'mastercard' | 'visa' | 'troy' | 'amex' | null {
  const a = String(association || '')
    .toUpperCase()
    .replace(/[\s-]/g, '_');
  if (a.includes('MASTER')) return 'mastercard';
  if (a.includes('VISA')) return 'visa';
  if (a.includes('TROY')) return 'troy';
  if (a.includes('AMERICAN') || a.includes('AMEX')) return 'amex';
  return null;
}

function MastercardMark() {
  return (
    <svg viewBox="0 0 40 24" className="h-6 w-10" aria-hidden>
      <circle cx="15" cy="12" r="10" fill="#EB001B" />
      <circle cx="25" cy="12" r="10" fill="#F79E1B" />
      <path d="M20 4.2a10 10 0 0 0 0 15.6 10 10 0 0 0 0-15.6z" fill="#FF5F00" />
    </svg>
  );
}

function VisaMark() {
  return (
    <svg viewBox="0 0 40 24" className="h-6 w-10" aria-hidden>
      <rect width="40" height="24" rx="3" fill="#1A1F71" />
      <text
        x="20"
        y="16.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="11"
        fontWeight="700"
        fontFamily="Arial, sans-serif"
        letterSpacing="1"
      >
        VISA
      </text>
    </svg>
  );
}

function TroyMark() {
  return (
    <svg viewBox="0 0 40 24" className="h-6 w-10" aria-hidden>
      <rect width="40" height="24" rx="3" fill="#4B2E83" />
      <text
        x="20"
        y="16.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="10"
        fontWeight="700"
        fontFamily="Arial, sans-serif"
      >
        TROY
      </text>
    </svg>
  );
}

function AmexMark() {
  return (
    <svg viewBox="0 0 40 24" className="h-6 w-10" aria-hidden>
      <rect width="40" height="24" rx="3" fill="#2E77BC" />
      <text
        x="20"
        y="16.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="8"
        fontWeight="700"
        fontFamily="Arial, sans-serif"
      >
        AMEX
      </text>
    </svg>
  );
}

export function SavedCardBrandIcon({ association }: { association?: string | null }) {
  const brand = brandKey(association);
  if (brand === 'mastercard') return <MastercardMark />;
  if (brand === 'visa') return <VisaMark />;
  if (brand === 'troy') return <TroyMark />;
  if (brand === 'amex') return <AmexMark />;
  return <CreditCard className="size-6 text-hzc_beige_700" />;
}
